'use client';

import { cn } from 'cn';
import ClaiLogo from '@/assets/icons/20-colored-clai-logo.svg';

/* Shared spring config + layout for the Clai FAB pill and greeting card. */
export const FAB_EASE = [0.16, 1, 0.3, 1] as const;
export const FAB_POSITION = 'fixed right-3 bottom-3 z-40 sm:right-6 sm:bottom-6';
export const fabEnterExit = {
  initial: {
    opacity: 0,
    scale: 0.85,
    y: 8
  },
  animate: {
    opacity: 1,
    scale: 1,
    y: 0
  },
  exit: {
    opacity: 0,
    scale: 0.85,
    y: 8
  }
} as const;
export const fabMdComponents = {
  p: ({
    children
  }: {
    children?: React.ReactNode;
  }) => <p className="text-background/80 text-[13px] leading-relaxed">{children}</p>,
  strong: ({
    children
  }: {
    children?: React.ReactNode;
  }) => <strong className="text-background font-semibold">{children}</strong>,
  ul: ({
    children
  }: {
    children?: React.ReactNode;
  }) => <ul className="mb-1.5 space-y-1 last:mb-0">{children}</ul>,
  li: ({
    children
  }: {
    children?: React.ReactNode;
  }) => <li className="text-background/80 flex gap-2 text-[13px] leading-relaxed">
      <span className="bg-background/50 mt-[0.4rem] h-1 w-1 shrink-0 rounded-full" />
      <span>{children}</span>
    </li>,
  a: ({
    href,
    children
  }: {
    href?: string;
    children?: React.ReactNode;
  }) => <a href={href} target="_blank" rel="noopener noreferrer" className="text-background/90 underline" onClick={e => e.stopPropagation()}>
      {children}
    </a>,
  img: () => null
} as const;

/* Logo + shine helper (used in both the compact pill and the greeting card) */
export function ClaiLogoWithShine({
  size = 'h-7 w-7'
}: {
  size?: string;
}) {
  return <div className={cn('relative shrink-0 overflow-hidden rounded-[4px]', size)} data-sentry-component="ClaiLogoWithShine" data-sentry-source-file="clai-fab-visuals.tsx">
      {/* Explicit dimensions prevent mobile WebKit from collapsing the inline SVG. */}
      <ClaiLogo className={size} style={{
      width: '100%',
      height: '100%'
    }} aria-hidden data-sentry-element="ClaiLogo" data-sentry-source-file="clai-fab-visuals.tsx" />
      <span className="animate-logo-shine absolute inset-y-0 w-[60%] skew-x-[-20deg] bg-linear-to-r from-transparent via-white/40 to-transparent motion-reduce:animate-none" />
    </div>;
}